var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"30px","display":"flex","align-items":"center"}},[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":require("../../assets/images/logo.png")}}),_c('h2',{staticStyle:{"padding-left":"20px"}},[_vm._v("纵横二加一网络信息科技有限公司")])])
}]

export { render, staticRenderFns }